<div class="row margin-none col-half">
    <!-- Clients -->
    <div class="col-md-6 col-sm-12 half box-dark padding-all-20 center">
        <!-- Section Header -->
        <h4 class="title-big center">उपयुक्त लिंक्स</h4>
        <div class="section-header">
            <div class="col-md-12 col-sm-12 padding-none">
                <div class="grid-list counter-list">
                    <div class="row margin-none">
                        <div class="grid col-md-6 col-sm-6">
                            <a href="https://nmpksbank.in/assets/ac.pdf" style="color: #FFF;" target="_black">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="245" data-speed="5000" data-refresh-interval="50"></span>
                                <p class="line-bottom text-extrabold">अकाउंट ओपनिंग फॉर्म</p>
                            </a>
                        </div>
                        <div class="grid col-md-6 col-sm-6">
                            <span class="countTo text-semibold text-space" data-from="0" data-to="820" data-speed="5000" data-refresh-interval="50">
                    </span>
                            <p class="line-bottom text-extrabold">ATM सुविधा</p>
                        </div>

                        <div class="grid col-md-6 col-sm-6">
                            <a href="https://play.google.com/store/apps/details?id=com.vgipl.nmksb" style="color: #FFF;" target="_black">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="98" data-speed="5000" data-refresh-interval="50"></span>
                                <p class="line-bottom text-extrabold">Download NMPKS Bank Viewing app</p>
                            </a>
                        </div>

                        <div class="grid col-md-6 col-sm-6">
                            <a routerLink="/about/branches" style="color: #FFF;">
                                <span class="countTo text-semibold text-space" data-from="0" data-to="32" data-speed="5000" data-refresh-interval="50"></span>
                                <p class="line-bottom text-extrabold">Bank IFSC Code</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-sm-12 half box-yellow padding-all center">
        <!-- <marquee direction="left" *ngFor="let user of dataNews">
        <div class="section-header">
            <h3>Wish you a very Happy Healthy & Prosperous New Year 2021. - - - Caution : Never ever share your Card number, Expiry date, CVV, PIN, OTP, Password with anyone. Bank never asks for such details.</h3>
        </div>
        <div class="section-header">
            <h2>{{user.nmpk_newsTitle}}</h2>
            <h3>{{user.nmpk_newsDesc.slice(0,50)}}...</h3>
        </div>
    </marquee> -->
        <h4 class="title-big center">बातमी</h4>
        <br>
        <div class="grid-list">
            <carousel [noWrap]="noWrapSlides" [showIndicators]="showIndicator">
                <slide class="" *ngFor="let item of dataNews">
                    <div class="wrapper" style="width: 100%;">
                        <div class="bx-wrapper" style="max-width: 100%;">
                            <div class="bx-viewport" style="width: 100%; overflow: hidden; position: relative;">
                                <ul class="bxslider" style="width: auto; position: relative;">
                                    <li style="float: none;">
                                        <div class="item center">
                                            <div class="item-comment">
                                                <b>"{{item.nmpk_newsTitle}}"</b>
                                            </div>
                                            <div class="item-name">
                                                {{item.nmpk_newsDesc.slice(0,50)}}...
                                            </div>
                                            <br>
                                            <button class="btn btn-dark btn-xs" routerLink='about/news'>संपूर्ण बातमी</button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </slide>
            </carousel>

        </div>
    </div>
</div>